import { Button } from '../../components/Form/Button';
import { useTranslation } from '../../i18n/i18n';
import { useHistory, useParams } from 'react-router-dom';
import './EditOrderFooter.css';

type EditOrderFooterProps = { disabled: boolean; submit: () => void; loading: boolean };
type UrlParams = { orderId: string };

export const EditOrderFooter = ({ disabled, submit, loading }: EditOrderFooterProps): JSX.Element => {
	const t = { ...useTranslation().generic, urls: useTranslation().routes };
	const history = useHistory();
	const { orderId } = useParams<UrlParams>();

	return (
		<div className="edit-order-footer">
			<Button
				className="secondary"
				disabled={disabled || loading}
				onClick={() => history.push(`${t.urls.yourOrders}/${orderId}`)}
			>
				{t.cancel}
			</Button>
			<Button disabled={disabled || loading} onClick={() => submit()}>
				{!loading ? t.save : t.saving}
			</Button>
		</div>
	);
};
